import { dateCustom } from '../../../../components';
import { paramsApi } from '../../../../helpers';
import api from '../../../../helpers/api';
import apiOld from '../../../../helpers/apiOld';
import apiV3 from '../../../../helpers/apiV3';
import { setFiltered, loaded, loading } from '../../../../layout/redux/layoutActions';

const  generateDataName = (name, yrange) => {
    let y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
    return { x: name, y: y };
}
const nLojas = 5
const labelsType = [ 'Satisfação geral', 'Insatisfação geral', 'Pilares', 'Indicadores' ]
const listSwots = [
  {
    id: 'forca',
    title: 'Força',
    labels: labelsType,
    type: { min: 0, max: 100 },
    lojas: Array(nLojas).fill().map((_, i)=> `Loja ${i+1}`)
  },
  {
    id: 'fraqueza',
    title: 'Fraqueza',
    labels: labelsType,
    type: { min: 0, max: 100 },
    lojas: Array(nLojas).fill().map((_, i)=> `Loja ${i+1}`)
  },
  {
    id: 'ameaca',
    title: 'Ameaça', 
    labels: labelsType,
    type: { min: 0, max:100 },
    lojas: Array(nLojas).fill().map((_, i)=> `Loja ${i+1}`)
  },
  {
    id: 'oportunidade',
    title: 'Oportunidade',
    labels: labelsType,
    type: { min: 0, max: 100 },
    lojas: Array(nLojas).fill().map((_, i)=> `Loja ${i+1}`)
  }
]

const listasMock = {
  swots: listSwots.map(l=> ({
    id: l.id,
    title: l.title,
    swot: l.labels.map(label=> ({
      name: label,
      data: l.lojas.map(loja=> {
        return generateDataName(loja,{ min: 0, max: 100 })
      })
    }))
  }))
}

export const setTotalAvaliacao = payload => ({
  type: 'INFO_SWOTS_TOTAL_AVALIACAO',
  payload
})

export const setFiltersProvisorio = payload => ({
  type: 'INFO_FILTERS_SWOTS',
  payload
})

export const putFiltersProvisorio = payload => ({
  type: 'CHANGE_FILTERS_SWOTS',
  payload
})

export const cleanFiltersProvisorio = () => ({
  type: 'CLEAN_FILTERS_SWOTS',
})


export const setListarSwots = payload => ({
  type: 'LIST_SWOTS',
  payload
})

export const setLoadList = payload => ({
  type: 'LOAD_LIST_SWOTS',
  payload
})


export const setListarPlano = payload => ({
  type: 'PLANO30DIAS_LIST_PLANOS',  // ← Apenas este mudado
  payload
})


export const setFiltersPlanos = payload => ({
  type: 'INFO_FILTERS_PLANO',
  payload
})

export const resetPlanejamento = () => ({
  type: 'RESET_PLANEJAMENTO'
})


// export const listarSwots = e => {

//   return dispatch => dispatch([
//     setListarSwots(listasMock.swots),
//   ])

//   let params = paramsApi({})
//   return dispatch => {
//     api.get(`urlendpoint${params}`)
//     .then(result => {
//       dispatch(setListarSwots(result.data))
//     })
//     .catch(err => {
//         console.error(err);
//     });
//   }
// }

// export const filterHandle = ({projetoID, params, filterActive, typeSelect}) => {
//   return dispatch => dispatch([
//     setFiltered(params),
//     setListarSwots(listasMock.swots)
//   ])


//   let paramsf = paramsApi({})
//   return dispatch => {
//     api.get(`urlendpoint${params}`)
//     .then(result => {
//       dispatch([
//         setListarSwots(listasMock.graficos)
//       ])
//     })
//     .catch(err => {
//         console.error(err);
//     });
//   }
// }



export const filtersCustom = ({filters, typeSelect}) => {
  let paramsFilter = {}
  const dataAtual = new Date()
  if (typeSelect?.id === 'Ciclo') {
    if (filters?.ciclo?.mesAno) {
      paramsFilter = {
        intervalo: `${filters.ciclo.anoMes}`,
      }
    }
  }
  if (typeSelect?.id === 'Data') {
    paramsFilter = {
      intervalo: `${dateCustom(filters.dataInicial).data} ${dateCustom(filters.dataFinal).data}`,
    }
  }
  if (filters?.categoria?.categoriaId) {
    paramsFilter = {
      ...paramsFilter,
      categoriaId: filters.categoria.categoriaId,
    }
  }
  return paramsFilter
}
const labelSwots = {
    forca: 'Força',
    ameaca: 'Ameaça',
    oportunidade: 'Oportunidade',
    fraqueza: 'Fraqueza',

    insatisfacaoGeral: 'Insatisfação geral',
    satisfacaoGeral: 'Satisfação geral',
    preco: 'Preço',
    atendimento: 'Atendimento',
    produto: 'Produto',
    indicadores: 'Indicadores',
    loja: 'Loja',
    
    
    
  }
const listSCustomSwot = e => {
  const swotList = Object.keys(e).filter(f=> f !== 'qtdeAvaliacoes').map(swot=> {
    return {
      id: swot, 
      title: labelSwots[swot],
      swot:  Object.keys(e[swot]).map(s=> {
        let infoResp = e[swot][s]
        if (typeof e[swot][s] === 'string') {
          infoResp = e[swot][s].split(',')
        }
        return {
          id: s,
          label: labelSwots[s],
          info: infoResp
        }
      }), 
    }
  })
  return swotList
}

export const listarSwots = ({
  projetoID,
  empresaId,
  planejamento,
  grupo,
  idioma1,
  filters={}, 
  typeSelect={}, 
  paginate = {pageNumber: 1, perPage: 7}
}) => {
  return dispatch => {
    dispatch(setLoadList(true)); // Início do carregamento

    let params = paramsApi({
      empresaId,
      IdiomaIdUser: idioma1,
      framework: 'YT30dias',
      ...planejamento?.idPlanejamento ? { IdPlanejamento: planejamento.idPlanejamento } : {},
      ...filters,
    });

    dispatch(loading());

    apiV3.get(`/Front/ListaUltimosPlanejamentos${params}`)
      .then(result => {
        // Definição do estado de paginação quando há retorno de dados
        const initialStatePaginate = { 
          pageNumber: result.data.pageAtual, 
          totalPages: result.data.totalPaginas,  
          totalElements: result.data.totalRegistros, 
          perPage: result.data.rpp,
        };

        if (!result.data || !result.data.planejamentoescolhido) {
          // Se não houver planejamento retornado, define uma mensagem padrão
          dispatch(setListarPlano({
            planejamentoescolhido: { descricao: 'Sem dados para exibir.' }
          }));
        } else {
          dispatch(setListarPlano(result.data));
        }

        //console.log("TOTALAVAL", result.data.qtdeAvaliacoes)
        dispatch(setTotalAvaliacao(result.data.qtdeAvaliacoes || 0));
        dispatch(setLoadList(false)); // Finaliza o carregamento no sucesso
      })
      .catch(err => {
        console.error(err);

        // Definição do estado de paginação quando ocorre erro
        const initialStatePaginate = { 
          pageNumber: 1, 
          totalPages: 1,  
          totalElements: 0, 
          perPage: paginate.perPage
        };

        // Em caso de erro, define a mensagem de erro no estado
        dispatch(setListarPlano({
          planejamentoescolhido: { descricao: 'Erro no retorno do planejamento.' }
        }));
        
        dispatch(setListarSwots([])); // Zera os dados do planejamento
        dispatch(setTotalAvaliacao(0));
        dispatch(setLoadList(false)); // Finaliza o carregamento no erro
      })
      .finally(() => {
        dispatch(loaded());
      });
  };
};




export const filterHandle = ({
  projetoID, 
  empresaId,
  grupo,
  params, 
  filtersProvisorio, 
  typeSelect, 
  paginate,
  idioma,
  semPlanejamento = false // 👈 novo parâmetro com valor padrão
}) => {
  //const paramsCustom = {...params, idPlanejamento: params?.idPlanejamento}


  const paramsCustom = {
    ...params,
    ...(filtersProvisorio?.planejamento?.idPlanejamento
      ? { idPlanejamento: filtersProvisorio.planejamento.idPlanejamento }
      : {})
  }
  const idioma1 = idioma;
  let paramsFilter = filtersCustom({filters: paramsCustom, typeSelect})

  const planejamento = semPlanejamento ? {} : filtersProvisorio.planejamento;

  console.log("filtersProvisorio.planejamento em Actions",filtersProvisorio.planejamento)
  return dispatch => dispatch([
    setFiltersPlanos(paramsCustom),
    //listarSwots({projetoID, empresaId, grupo, filters: paramsFilter, paginate, typeSelect, idioma1, planejamento: filtersProvisorio.planejamento}),
    listarSwots({projetoID, empresaId, grupo, filters: paramsFilter, paginate, typeSelect, idioma1, planejamento}),
  
  ])
}

